import React, { useState, useEffect } from 'react';
import styles from './Settings.module.css';
import apiClient from '../../../api/client';

const Settings = () => {
  const [settings, setSettings] = useState({
    platformName: '',
    supportPhone: '',
    academicYear: '',
    adminName: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');

  useEffect(() => {
    apiClient.get('/settings')
      .then(res => setSettings(res.data))
      .catch(err => console.error('❌ مشكلة في جلب الإعدادات:', err))
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await apiClient.put('/settings', settings);
      setSettings(data);
      alert('تم حفظ الإعدادات بنجاح!');
    } catch (error) {
      alert('حصل خطأ أثناء حفظ الإعدادات');
    } finally {
      setSaving(false);
    }
  };

  const handleChangePassword = async () => {
    setPasswordMessage('');
    if (!currentPassword || !newPassword) {
      setPasswordMessage('لازم تدخل كلمة المرور الحالية والجديدة');
      return;
    }
    try {
      await apiClient.put('/auth/password', { currentPassword, newPassword });
      setPasswordMessage('✅ تم تغيير كلمة المرور بنجاح');
      setCurrentPassword('');
      setNewPassword('');
    } catch (error) {
      setPasswordMessage(error.response?.data?.message || 'حصل خطأ أثناء تغيير كلمة المرور');
    }
  };

  if (loading) return <div className={styles.pageWrapper}>جاري تحميل الإعدادات...</div>;

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>إعدادات النظام</h1>
      </div>

      <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column' }}>

        {/* القسم الأول: إعدادات المنصة */}
        <div className={styles.settingsCard}>
          <h2 className={styles.sectionTitle}>🏢 بيانات المنصة الأساسية</h2>
          <div className={styles.formGrid}>
            <div className={styles.inputGroup}>
              <label>اسم المنصة</label>
              <input
                type="text"
                className={styles.input}
                value={settings.platformName}
                onChange={(e) => setSettings({ ...settings, platformName: e.target.value })}
                required
              />
            </div>
            <div className={styles.inputGroup}>
              <label>رقم هاتف الدعم (لأولياء الأمور)</label>
              <input
                type="tel"
                className={styles.input}
                value={settings.supportPhone}
                onChange={(e) => setSettings({ ...settings, supportPhone: e.target.value })}
                required
              />
            </div>
            <div className={styles.inputGroup}>
              <label>العام الدراسي الحالي</label>
              <select
                className={styles.input}
                value={settings.academicYear}
                onChange={(e) => setSettings({ ...settings, academicYear: e.target.value })}
              >
                <option value="2025-2026">2025 - 2026</option>
                <option value="2026-2027">2026 - 2027</option>
              </select>
            </div>
            <div className={styles.inputGroup}>
              <label>اسم المستخدم (يظهر في القائمة)</label>
              <input
                type="text"
                className={styles.input}
                value={settings.adminName}
                onChange={(e) => setSettings({ ...settings, adminName: e.target.value })}
                required
              />
            </div>
          </div>
        </div>

        {/* زرار الحفظ */}
        <button type="submit" className={styles.saveBtn} disabled={saving}>
          {saving ? 'جاري الحفظ...' : 'حفظ التعديلات'}
        </button>
      </form>

      {/* القسم الثاني: تغيير كلمة المرور */}
      <div className={styles.settingsCard} style={{ marginTop: '1.5rem' }}>
        <h2 className={styles.sectionTitle}>🔒 تغيير كلمة المرور</h2>
        {passwordMessage && (
          <p style={{ color: passwordMessage.startsWith('✅') ? '#16a34a' : '#b91c1c', fontWeight: '600' }}>
            {passwordMessage}
          </p>
        )}
        <div className={styles.formGrid}>
          <div className={styles.inputGroup}>
            <label>كلمة المرور الحالية</label>
            <input
              type="password"
              className={styles.input}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </div>
          <div className={styles.inputGroup}>
            <label>كلمة المرور الجديدة</label>
            <input
              type="password"
              className={styles.input}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
        </div>
        <button type="button" className={styles.saveBtn} onClick={handleChangePassword}>
          تغيير كلمة المرور
        </button>
      </div>
    </div>
  );
};

export default Settings;
